import "./contact.scss"

export default function Contact() {
    return (
        <div className="contact sections-page sections-page-4" id="contact">
            <div className="container contact-landing-container">
                <div className="row contact-container">
                    <div className="col-12 d-sm-none sm-title d-none">
                        <p>Contact</p>
                    </div>
                    <div className="col-12 text-center">
                        <div className="form-label">
                            <p className="message">Get in touch</p>
                            <p className="sub-message mb-0">Currently employed,</p>
                            <p className="sub-message">but feel free to send a message if you are interested.</p>
                            <p className="sm-message">Open for light freelance work.</p>
                        </div>
                        <a href="mailto:kelvincalinisan018@gmail.com" target="_blank" rel="nofollow noopener noreferrer" title="Send Mail" className="contact-button mail-button btn btn-primary">
                            Say Hello
                        </a>
                        {/* <a className="contact-button cv-button btn btn-primary" href="/John-Kelvin-Calinisan-Resume-qr-2022.pdf" title="Download CV" download><i className="fas fa-file-download"></i> CV</a> */}
                    </div>
                    <div className="col-12 circle-btn-container">
                        <a className="contact-circle-btn btn btn-default" title="Facebook" href="https://www.facebook.com/martianvin018/" target="_blank" rel="noreferrer" >
                            <i className="fab fa-facebook"></i>
                        </a>
                        <a className="contact-circle-btn btn btn-default" title="Instagram" href="https://www.instagram.com/kjkjkjkelvin/" target="_blank" rel="noreferrer" >
                            <i className="fab fa-instagram"></i>
                        </a>
                        <a className="contact-circle-btn btn btn-default" title="LinkedIn" href="https://www.linkedin.com/in/johnkelvincalinisan/" target="_blank" rel="noreferrer" >
                            <i className="fab fa-linkedin"></i>
                        </a>
                        <a className="contact-circle-btn btn btn-default" title="Gmail" href="mailto:kelvincalinisan018@gmail.com" target="_blank" rel="nofollow noopener noreferrer" >
                            <i className="far fa-envelope"></i>
                        </a>
                        <a className="contact-circle-btn btn btn-default" title="GitHub" href="https://github.com/kjkjkjkelvin" target="_blank" rel="noreferrer" >
                            <i className="fab fa-github"></i>
                        </a>
                        
                    </div>
                </div>
            </div>
            <div className="parallax-background"></div>  
        </div>
    )
}
